import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
const EMAIL_REGEXPR = /^\S+@\S+\.\S+$/;

export function emailValidator(
  control: AbstractControl,
  field: FormlyFieldConfig,
  options?: { [id: string]: any; }) {
  if (field.type === 'input' && field.templateOptions && field.templateOptions.type === 'email') {
    if (control.value && !control.value.match(EMAIL_REGEXPR)) {
      return { email: { message: 'Niepoprawny format adresu email' } }
    }
  }
  return null;
}
